import { useTranslation } from 'react-i18next'
import { Button, Spin, Tooltip } from 'antd'
import { useEffect, useState } from 'react'
import { evaluationsService } from 'api/courses/evaluations'
import { Wrapper, TooltipTitle } from './styled'
import { useEvaluation } from './../contexts/Evaluation'
import Results from './results'

const Buttons = () => {
  const { t } = useTranslation()
  const [isProcessing, setIsProcessing] = useState(false)
  const [viewResults, setViewResults] = useState(false)
  const [hasPendingQuestions, setHasPendingQuestions] = useState(false)
  const [tooltipTitle, setTooltipTitle] = useState('')
  const { evaluation, sections, isAnySaving, checkForEvaluationUpdates } =
    useEvaluation()
  const translationPrefix = 'lessons.contentBlocks.evaluation'

  useEffect(() => {
    if (sections.data) {
      setHasPendingQuestions(
        sections.data.some((section) =>
          section.questions.some(
            (question) => question.userAnswer?.response === null
          )
        )
      )
    }
  }, [sections.data])

  useEffect(() => {
    if (hasPendingQuestions || isAnySaving) {
      setTooltipTitle(
        t(
          `${translationPrefix}.${
            hasPendingQuestions ? 'pendingQuestions' : 'savingAnswers'
          }`
        )
      )
    } else {
      setTooltipTitle('')
    }
  }, [hasPendingQuestions, isAnySaving, t])

  const finishEvaluation = async () => {
    setIsProcessing(true)

    try {
      const isCurrentVersion = await checkForEvaluationUpdates()
      if (!isCurrentVersion) {
        setIsProcessing(false)
        return
      }

      await evaluationsService.finishEvaluation(
        Number(evaluation.evaluationResponse?.id)
      )
      setViewResults(true)
    } catch (error) {
      console.error('Error finishing evaluation:', error)
    } finally {
      setIsProcessing(false)
    }
  }

  const getPopupContainer = () => {
    return document.getElementById('lmsPage') as HTMLElement
  }

  const tooltipContent = tooltipTitle ? (
    <TooltipTitle>{tooltipTitle}</TooltipTitle>
  ) : undefined

  return (
    <>
      <Wrapper>
        <Spin spinning={isProcessing}>
          <Tooltip title={tooltipContent} getPopupContainer={getPopupContainer}>
            <Button
              onClick={finishEvaluation}
              disabled={hasPendingQuestions || isAnySaving}
            >
              {t(`${translationPrefix}.finishEvaluation`)}
            </Button>
          </Tooltip>
        </Spin>
      </Wrapper>
      {viewResults && (
        <Results evaluationId={evaluation.id} setViewResults={setViewResults} />
      )}
    </>
  )
}

export default Buttons
